import React, { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { LayoutContextProvider } from "./components/LayoutContext";
import StripeReturnURL from "./orgs/components/Settings/StripeReturnURL";
import RegistrationSuccess from "./components/registration2/Registrationsuccess";
// import Cookies from "js-cookie";

const About = lazy(() => import("./About"));
const AccountDash = lazy(() => import("./account/AccountDash"));
const Admin = lazy(() => import("./Admin"));
const Browse = lazy(() => import("./Browse"));
const CateringLive = lazy(() => import("./CateringLive"));
const Checkout = lazy(() => import("./order/Checkout"));
const Create = lazy(() => import("./Create"));
const Documentation = lazy(() => import("./documentation/Documentation"));
const Error = lazy(() => import("./Error"));
const Event = lazy(() => import("./Event"));
const FormBuilder = lazy(() => import("./orgs/components/FormBuilder"));
const InvoiceNoCard = lazy(() => import("./invoicenocard"));
const Learn = lazy(() => import("./learn/Learn"));
const LoginPage = lazy(() => import("./account/Loginpage"));
const Menu = lazy(() => import("./order/Menu"));
const Organization = lazy(() => import("./orgs/Organization"));
const OrgPagesFrontend = lazy(() => import("./orgs/pages/OrgPagesFrontend"));
const Passdash = lazy(() => import("./Passdash"));
const Pricing = lazy(() => import("./Pricing"));
const Promotion = lazy(() => import("./Promotion"));
// const Registration = lazy(() => import("./Registration"));
const Scan = lazy(() => import("./Scan"));
const Signup = lazy(() => import("./orgs/Signup"));
const SupportContactForm = lazy(() => import("./SupportContactForm"));
const SystemErrorsSupport = lazy(() => import("./SystemErrorsSupport"));
const TOS = lazy(() => import("./legal/tos"));
const Users = lazy(() => import("./Users"));
const Vendor = lazy(() => import("./Vendor"));
const VendorOrder = lazy(() => import("./order/Vendororder"));
const Registration2 = lazy(() => import("./Registration2"));
const ProgramCardPage = lazy(() => import("./program/programcard"));
const Auth = lazy(() => import("./auth/auth"));

const hostname = window.location.hostname;

// if (process.env.NODE_ENV === 'production') {
if (hostname === "advent.endevre.com") {
  console.log = () => {};
  console.table = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
  console.debug = () => {};
}

if (process.env.NODE_ENV === "development") {
  console.log(process.env);
  let currDate = new Date();
  console.log(
    "---------------------------------------------------------------------\n" +
      "  THIS IS A DEVELOPMENT BUILD       \n" +
      "                                         \n" +
      "  version   : " +
      process.env.REACT_APP_VERSION +
      "  \n" +
      "  date      : " +
      currDate.toDateString() +
      "\n" +
      "  live load : " +
      process.env.REACT_APP_DEV_DATE +
      "  \n" +
      "  build     : " +
      process.env.REACT_APP_BUILD +
      "  \n" +
      "                                         \n" +
      "  © Endevre Technologies LLC " +
      currDate.getFullYear() +
      "\n" +
      "---------------------------------------------------------------------"
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LayoutContextProvider>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route index element={<About />} />
            <Route path="error/:errorcode" element={<Error />} />
            <Route path="passdash" element={<Passdash />} />
            <Route path="passdash/:eventid" element={<Passdash />} />
            <Route path="passdash/:eventid/:currview" element={<Passdash />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="users" element={<Users />} />
            <Route path="about" element={<About />} />
            <Route path="menu" element={<Menu />} />
            <Route path="cateringlive" element={<CateringLive />} />
            <Route path="invoicenocard" element={<InvoiceNoCard />} />
            <Route path="programcard/:eventid" element={<ProgramCardPage />} />
            <Route
              path="programcard/:eventid/:cardid"
              element={<ProgramCardPage />}
            />
            {/* <Route
              path="registration/:eventid/:refid"
              element={<Registration />}
            /> */}
            {/* <Route path="registration/:eventid/" element={<Registration />} />
            <Route
              path="registration/edit/:eventid/:activationcode"
              element={<Registration />}
            />
            <Route
              path="registration/preview/:eventid/"
              element={<Registration preview={true} />}
            />
            <Route
              path="registration/preview/:eventid/:ticketid"
              element={<Registration preview={true} />}
            /> */}

            {/* registration 2 */}
            <Route path="registration/:eventid/" element={<Registration2 />} />
            <Route
              path="registration/:eventid/success/:orderid"
              element={<RegistrationSuccess />}
            />

            <Route path="vendor/:vendorid" element={<Vendor />} />
            <Route path="vendor/:vendorid/:currview" element={<Vendor />} />
            <Route
              path="vendor/:vendorid/:currview/:ordercardid"
              element={<Vendor />}
            />
            <Route path="vendor/:vendorid/order" element={<VendorOrder />} />

            <Route path="admin/:eventid/" element={<Admin />} />
            <Route path="admin/:eventid/:page/" element={<Admin />} />
            <Route
              path="admin/:eventid/:page/:selectionid"
              element={<Admin />}
            />
            <Route
              path="admin/:eventid/:page/:selectionid/:submenupage"
              element={<Admin />}
            />

            <Route path="scan" element={<Scan />} />
            <Route path="scan/:cardcode" element={<Scan />} />
            <Route
              path="support/systemerrors"
              element={<SystemErrorsSupport />}
            />
            <Route path="support/contact" element={<SupportContactForm />} />
            <Route path="promotion" element={<Promotion />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="login" element={<LoginPage />} />
            <Route path="account" element={<AccountDash />} />
            <Route path="account/:page" element={<AccountDash />} />
            <Route path="event" element={<Event />} />
            <Route path="event/:eventid" element={<Event />} />
            <Route path="event/:eventid/:page" element={<Event />} />
            <Route path="browse" element={<Browse />} />
            <Route path="organization/:orgid" element={<Organization />} />
            <Route
              path="organization/:orgid/:page"
              element={<Organization />}
            />
            <Route
              path="organization/:orgid/:page/:selectionid"
              element={<Organization />}
            />
            <Route
              path="organization/:orgid/:page/:subMenuItem"
              element={<Organization />}
            />
            <Route
              path="o/:orgid/settings/stripe/success"
              element={<StripeReturnURL status="success" />}
            />
            <Route
              path="o/:orgid/settings/stripe/fail"
              element={<StripeReturnURL status="fail" />}
            />

            <Route path="o/:orgid/interestform" element={<Signup />} />
            <Route path="o/:orgid" element={<OrgPagesFrontend />} />
            <Route
              path="o/:orgid/:selectedPage"
              element={<OrgPagesFrontend />}
            />

            <Route path=":customUrl" element={<OrgPagesFrontend />} />
            <Route
              path=":customUrl/:selectedPage"
              element={<OrgPagesFrontend />}
            />
            <Route path=":customUrl/interestform" element={<Signup />} />

            <Route path="learn/:page" element={<Learn />} />

            <Route path="docs" element={<Documentation />} />
            <Route path="docs/:topic" element={<Documentation />} />
            <Route path="docs/:_topic/:_section" element={<Documentation />} />

            <Route path="create" element={<Create />} />
            <Route path="create/:page" element={<Create />} />

            <Route path="legal/tos" element={<TOS />} />

            <Route path="formbuilder" element={<FormBuilder />} />

            <Route path="auth" element={<Auth />} />

            <Route path="*" element={<Navigate to="error/404" />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </LayoutContextProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
